import React, { useState, useContext, useEffect } from "react";
import { t } from "i18next";
import * as Yup from "yup";
import "yup-phone";
import { PrimaryButton, TextField } from "@fluentui/react";
import TechnicianContact from "../TechnicianContact";
import { ACTIONS, USERTYPES } from "../../../../constants/Constants";

// const ContactDetailsSchema = Yup.object().shape({
//   technicianContactList: Yup.array().of(
//     Yup.object().shape({
//       name: Yup.string()
//         .min(3, "Name must be at least 3 characters.")
//         .max(50, "Name must be at most 50 characters.")
//         .required("Name cannot be blank."),
//     })
//   ),
// });

const ContactDetailsSection = (props) => {
  console.log("Props in ContactDetailsSection : ", props);
  console.log("Usertype : ", props.userType);

  const [technicianContactList, setTechnicianContactList] = useState([]);

  const handleInputValidationMobile = (inputNumber, country) => {
    let targetLength = country.format.match(/\./g).length;
    let fixedLength = targetLength - country.dialCode.length;
    let inputTargetLength = inputNumber.length - country.dialCode.length;
    // console.log("--- Mobile Field Values ---",inputNumber,targetLength,fixedLength,inputTargetLength,country);
    if (
      inputTargetLength != fixedLength &&
      inputNumber.length > country.dialCode.length &&
      !(inputNumber.length >= 10 && fixedLength > 10)
    ) {
      console.log("--- Error in validation mobile field ---");
      props.setCustomMobileError(
        "For " + country.name + " (" + fixedLength + " digits required)"
      );
      return;
    }
    if (inputTargetLength == 0 || inputNumber.length < 2) {
      console.log("---- Error mobile field empty ----");
      setTimeout(() => {
        props.setCustomMobileError("Mobile cannot be blank");
      }, 100);
      return;
    }
    console.log("---- No error in mobile field -----");
    setTimeout(() => {
      props.setCustomMobileError(null);
    }, 100);
  };



  const handleTechnicianContactChange = (index, field, value) => {
    const updatedList = props.values.technicianContactList.map((contact, i) => {
      if (field === 'isPrimaryContact') {
        return i === index ? { ...contact, [field]: value } : { ...contact, [field]: 0 };
      }
      return i === index ? { ...contact, [field]: value } : contact;
    });
  
    props.setFieldValue("technicianContactList", updatedList);
  };

  const addTechnicianContact = async () => {
    console.log("addTechnicianContact called ---------");
    console.log("Pprops.values.technicianContactList : ", props.values.technicianContactList)
      props.setFieldValue("technicianContactList", [
        ...props.values.technicianContactList,
        { name: "", mobile: "",isPrimaryContact: 0  },
    ]);

    setTechnicianContactList([...technicianContactList, { name: "", mobile: "" }]);
    
    
  };


  const removeTechnicianContact = (index) => {
    const updatedList = props.values.technicianContactList.filter((_, i) => i !== index);
    // setTechnicianContactList(updatedList);
    props.setFieldValue("technicianContactList", updatedList);
  };

  useEffect(() => {
    console.log("In useeffect", props.technicianContactList);
  }, [props.technicianContactList])
  

  return (
    <>
      {/* ADD/EDIT */}
      {(props.state.action === ACTIONS.ADD ||
        props.state.action === ACTIONS.EDIT) && (
        <div className="tab-section">
          <section className="sectionA">
            <p
              style={{
                fontSize: "20px",
                fontWeight: "600",
                padding: "0px 0px",
                marginBottom: "10px",
              }}
            >
              {t("user.contact-details")}
              
            </p>
          </section>

          <div className="ms-Grid" dir="ltr">
            {props.values.technicianContactList &&
              props.values.technicianContactList.map((contact, index) => (
                <TechnicianContact
                  key={index}
                  index={index}
                  contact={contact}
                  handleTechnicianContactChange={handleTechnicianContactChange}
                  handleBlur={props.handleBlur}
                  touched={props.touched}
                  errors={props.errors}
                  handleInputValidationMobile={handleInputValidationMobile}
                  removeTechnicianContact={removeTechnicianContact}
                  state={props.state}
                />
              ))}

            <div className="view-page-buttons">
              <PrimaryButton
                className="view-page-button"
                text={t("button.add-more-contacts")}
                onClick={addTechnicianContact}
                disabled={
                  Object.keys(props.errors).length > 0 || // Disable if there are any validation errors
                  props.values.technicianContactList.some(
                    (contact) => !contact.name || !contact.mobile || props.customMobileError != null // Disable if any name or mobile is empty
                  )
                }
              />
            </div>
          </div>
        </div>
      )}

      {/* VIEW*/}
      {props.state.action === ACTIONS.VIEW && (
        <div className="tab-section">
          <section className="sectionA">
            <p
              style={{
                fontSize: "20px",
                fontWeight: "600",
                padding: "0px 0px",
                marginBottom: "10px",
              }}
            >
              {t("user.contact-details")}
            </p>
          </section>
          <div className="ms-Grid" dir="ltr">

            {props.values.technicianContactList.length <= 0 && (
              <div><p  style={{
                fontSize: "15px",
                fontWeight: "500",
                padding: "0px 0px",
                marginTop: "10px",
              }}>
                No additional contacts added
              </p></div>
            )}

            {props.values.technicianContactList.map((contact, index) => (
              <div
                className="ms-Grid-row"
                key={index}
                style={{ marginTop: "20px" }}
              >
                <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg3 ms-xl4">
                  <div className="form-heading">{t("user.name")}</div>
                  <div className="form-mt-10">{contact.name}</div>
                </div>
                <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg3 ms-xl4">
                  <div className="form-heading">{t("user.mobile")}</div>
                  <div className="form-mt-10">{contact.mobile}</div>
                </div>
                {contact.isPrimaryContact == 1 && (
                  <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg3 ms-xl4">
                  <div className="form-mt-10">Primary Contact</div>
                </div>
                )}
              </div>
            ))}
          </div>
        </div>
      )}
    </>
  );
};

export default ContactDetailsSection;
